export default "__VITE_ASSET__cce02c91__"